<template>
  <v-app id="app">
    <v-progress-circular
      class="load-spinner"
      indeterminate
      color="primary"
      v-show="isLoading"
      size="70"
      width="7"
    ></v-progress-circular>

    <v-app-bar app dense>
      <div class="logo-wrapper">
        <a href="/">
          <img class="logo" src="/static/vladlink-logo.png" alt="">
        </a>
      </div>
    </v-app-bar>


    <!-- Успешная оплата-->
    <v-content class="app_layout" v-if="this.currentRoute==='/success/'">
      <v-container>
        <payment-success-component />
      </v-container>
    </v-content>

    <v-content class="app_layout" v-else-if="userName">
      <MobileAppProposal/>
      <!--      Оплата банковской картой -->
      <v-container>
        <v-layout row>
          <v-flex xs12 text-left class="v-label theme--light">
            <h3 class="shifted">Лицевой счет: {{this.uid}} </h3>
            <h3 class="shifted">Счет оформлен на: {{this.userName}}</h3>
          </v-flex>
        </v-layout>

        <pay-handler-component :uid="uid" v-if="this.userName" @loading-toggled="toggleLoading"
                               @getPayOptions="setSberPay" :do-show-sber="doShowSber"
                               @backToMain="doShowSber = false"
        ></pay-handler-component>

        <div class="d-flex flex-column flex-md-row-reverse justify-md-end container pt-0">
          <v-btn
            v-if="sberOnlineData && !doShowSber"
            color="primary"
            class="ml-md-2 mb-1 mb-sm-5 mb-xs-5"
            @click="doShowSber = true"
          >
            {{sberOnlineData.name}}
          </v-btn>
          <v-btn color="primary" @click="this.reset">
            Другой лицевой счет
          </v-btn>
        </div>
      </v-container>
    </v-content>

    <v-content v-else class="app_layout">
      <MobileAppProposal/>

      <!--      Ввод лицевого счета-->
      <v-container class="my-10">
        <v-flex style="margin-top: 10px">
          <v-text-field @keyup.enter="initPage()" v-mask="'######'" v-model="uid"
                        v-bind:disabled="isUidInputOff" autofocus label="Введите номер лицевого счета"
                        @keydown="isUidExists = null" type="number"></v-text-field>
          <v-btn id="loginBtn" v-bind:disabled="isUidInputOff" color="primary"
                 :class="{ loginButton: true, fullWidth: $vuetify.breakpoint.smAndDown}"
                 @click="initPage()">
            Ввод
          </v-btn>
          <span v-if="isUidExists===false" class="red--text">Лицевой счет не найден</span>
        </v-flex>
        <banner image="cashback_banner"></banner>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import axios from 'axios';
  import PayHandlerComponent from './components/PayHandlerComponent.vue';
  import PaymentSuccessComponent from './components/PaymentSuccessComponent';
  import MobileAppProposal from './components/MobileAppProposal';
  import Banner from "./components/Banner";

  export default {
    name: 'app',
    components: {MobileAppProposal, PayHandlerComponent, PaymentSuccessComponent, Banner},
    data() {
      return {
        userName: '',
        uid: '',
        isUidExists: null,
        isUidInputOff: true,
        isRobot: false,
        isLoading: false,
        currentRoute: null,
        referer: null,
        metricsData: null,
        sberOnlineData: null,
        doShowSber: false,
      };
    },

    methods: {
      toggleLoading: function () {
        this.isLoading = !this.isLoading;
      },

      getFullName: function() {
        if (isFinite(this.uid) && this.uid > 0 && this.uid < 500000) {
          axios(process.env.REST_SERVICE + '/public/users/fullname?id=' + this.uid).
            then(this.formatName).
            catch(error => {
              this.reset();
              this.isUidExists = false;
            });
        } else {
          let uid = this.uid;
          this.reset();
          if (uid)
            this.isUidExists = false;
        }
      },

      formatName: function(response) {
        this.userName = response.data.data;
        this.uid = this.uid.toString();
        while (this.uid.length < 6) {
          this.uid = '0' + this.uid;
        }
      },

      reset: function() {
        this.uid = '';
        this.userName = '';
        this.isUidExists = null;
        this.isUidInputOff = false;
        this.sberOnlineData = null;
        this.doShowSber = false;
      },

      initPage: function() {
        if (this.uid) {
          this.getFullName();
          this.getMetrikaData();
        }
      },

      getMetrikaData: function() {
        if (!this.uid) {
          return;
        }

        axios(process.env.REST_SERVICE + '/public/users/metrika/' + this.uid).then(response => {
          this.metricsData = response.data.data[0];
          // Преобразуем данные в числа (кроме uid)
          for (const [key, val] of Object.entries(response.data.data[0])) {
            if (key === 'ut_id') {
              continue;
            }
            this.metricsData[key] = +val;
          }
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.innerHTML = `
            var dataLayer=[${JSON.stringify(this.metricsData, null, ' ')}];
            console.log(dataLayer);
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-P2ZQTM9');
          `;
          document.head.appendChild(script);
        });
      },

      /**
       * Данные по Сбербанк Онлайн
       * @param data {array}
       */
      setSberPay(data) {
        this.sberOnlineData = data;
      },
    },

    created: function() {
      const url = new URL(location.href);
      this.currentRoute = url.pathname;
      this.orderId = url.searchParams.get('orderId');
      this.referer = url.searchParams.get('referer');
      let uri = window.location.href.split('/?');
      if (uri.length === 2) {
        this.uid = uri[1];
        //this.recaptcha('site_in');
        this.initPage();
      } else {
        this.isUidInputOff = false;
      }
    },

  };
</script>

<style scoped>
  .shifted {
    margin-left: 20px;
  }

  .app_layout {
    flex: 0 1 auto;
    position: relative;
    min-width: 1px;
    max-width: 900px;
    margin: 0 auto;
    z-index: 1;
    width: 100%; /* 2 */
    max-height: max-content;
    min-height: 1px;
    height: auto;
  }

  .load-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
  }

  .logo-wrapper {
    margin-left: auto;
    margin-right: auto;
    height: 100%;
  }

  .logo {
    height: 100%;
    padding: 5px 0;
  }

  .theme--light {
    color: #4c4c4c;
  }

  .loginButton {
    width: 130px;
  }

  .fullWidth {
    width: 100%;
  }

  .v-btn {
    box-shadow: none !important;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue